import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b701e35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bus-stops",
  role: "list",
  "aria-label": "정류장 목록"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    ($setup.arrangedBusStops.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.arrangedBusStops, (busStop, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: busStop.id
          }, [
            _createVNode($setup["BusStopRow"], {
              selectedArrivalTimeOption: $props.selectedArrivalTimeOption,
              index: index,
              busStop: busStop,
              selectedBus: $props.selectedBus,
              id: busStop.id,
              showInMainCard: $props.showInMainCard,
              busLocations: $props.busLocations,
              showBottomDivider: index !== $setup.arrangedBusStops.length - 1,
              selectComplete: $props.selectComplete,
              boardingBusStop: $props.boardingBusStop,
              arrivalBusStop: $props.arrivalBusStop,
              isInsideShuttle: $props.isInsideShuttle,
              isBackwardLine: $props.isBackwardLine,
              firstBusStopId: $setup.arrangedBusStops[0]?.id,
              isLastRow: index === $setup.arrangedBusStops.length - 1,
              arrivalTimesForDisplay: $props.arrivalTimesForDisplay[index],
              nextBusStopId: 
            index + 1 < $setup.arrangedBusStops.length
              ? $setup.arrangedBusStops[index + 1].id
              : ''
          ,
              shouldShowGetOffBell: $props.shouldShowGetOffBell,
              allBusesMap: $props.allBusesMap,
              lineId: $props.lineId,
              turnId: $props.turnId,
              isBookable: $props.isBookable,
              isOnBoarding: $props.isOnBoarding,
              activatedGetOffBell: busStop.id === $props.requestGetOffBusStopId,
              favoriteGetOnBusStop: $props.favoriteGetOnBusStop,
              favoriteGetOffBusStop: $props.favoriteGetOffBusStop,
              detourEndDtm: $props.detourEndDtm,
              shouldShowBusLocations: $props.shouldShowBusLocations,
              shouldShowBusStopLocation: $props.shouldShowBusStopLocation,
              onToggleSelectBusStop: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSelectBusStop', $event))),
              onOnClickBusStopLocation: ($event: any) => (_ctx.$emit('onClickBusStopLocation', busStop)),
              onOnClickScheduleBtn: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClickScheduleBtn', $event))),
              onOnClickGetOffBell: $setup.emitOnClickGetOffBell,
              onOnClickBubble: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onClickBubble'))),
              onOnClickBusIcon: $setup.emitOnClickBusIcon,
              onOnClickFavoriteStatusButton: $setup.emitOnClickFavoriteStatusButton
            }, null, 8 /* PROPS */, ["selectedArrivalTimeOption", "index", "busStop", "selectedBus", "id", "showInMainCard", "busLocations", "showBottomDivider", "selectComplete", "boardingBusStop", "arrivalBusStop", "isInsideShuttle", "isBackwardLine", "firstBusStopId", "isLastRow", "arrivalTimesForDisplay", "nextBusStopId", "shouldShowGetOffBell", "allBusesMap", "lineId", "turnId", "isBookable", "isOnBoarding", "activatedGetOffBell", "favoriteGetOnBusStop", "favoriteGetOffBusStop", "detourEndDtm", "shouldShowBusLocations", "shouldShowBusStopLocation", "onOnClickBusStopLocation"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}